import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import SeniorServicesDetails from '../mendepartmentdetails/SeniorServices'


function SeniorServices() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Senior Services || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Senior Services"
            subtitledown="Department of Senior Services"
           />
            <SeniorServicesDetails/>
        </div>
    </>
  )
}

export default SeniorServices